import { render, staticRenderFns } from "./MoneyShop.vue?vue&type=template&id=5619676c&"
import script from "./MoneyShop.vue?vue&type=script&lang=js&"
export * from "./MoneyShop.vue?vue&type=script&lang=js&"
import style0 from "./MoneyShop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports